/**
 * Serves a module, which can be started separately to require the user login
 */

import SetVersionDocumentTitle from 'gw-portals-platform-angular/versionName/SetVersionDocumentTitle';
import AuthComponentUtils from 'gw-portals-auth-angular/components/common/AuthComponentUtils';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import AuthenticationService from 'gw-portals-auth-js/AuthenticationService';

// VARS

// ui-view vars
var uiViewAttr = 'ui-view';
var uiViewHtml = '<div ' + uiViewAttr + '></div>';
var $initialUiView = $(document.body).children('[' + uiViewAttr + ']');

// initial hash logic
var initialHash = window.location.hash;

// METHODS
/**
 * Restores the exact URL hash, which the user might have
 * before starting to interact with the auth app
 */
function restoreInitialHash() {
    if (!initialHash) {
        return;
    }
    window.location.hash = initialHash; // restore an initial hash
    console.log('from original hash function' + window.location.hash);
}

function restoreLoginHash() {
    //test
    window.location.hash = '#/auth/login';
    console.log('from original hash function' + window.location.hash);
}

// user info logic
/**
 * Updates the user info to be used in the Portal app
 * @param {Object} UserInfoService
 * @param {String} userType
 * @param {String} publicId
 */
function updateUserInfo(UserInfoService, userType, publicId) {
    UserInfoService.setUserInfo({
        userType: userType
    });

    UserInfoService.setUserPublicId(publicId);
}

// applications interaction logic
/**
 * Destroys the auth app
 * @param {Object} $rootScope
 */
function destroyAuthApp($rootScope) {
    // Destroy the auth app
    $rootScope.$destroy(); // Destroy the scope tree
    $(document.body).children('[' + uiViewAttr + ']').remove(); // Remove node from the DOM. Also wipes related data stored on the node.
}

/**
 * Triggers usual Portal app loading
 * @param {Function} loadPortal
 */
function triggerPortalLoad(loadPortal) {
    $(document.body).append(uiViewHtml); // include required ui-view
    loadPortal(); // trigger the usual Portal app
}

/**
 * @param {Function} loadPortal function to trigger the usual Portal loading
 */
export default (function (loadPortal) {
    var initialAppName = 'initialauthapp'; // custom unique name

    angular.module(initialAppName, ['edge.platform.auth'] // depends on and triggers the auth module
    ).run(['$timeout', 'oAuth', '$rootScope', 'gwAuthTokenService', '$q', 'UserInfoService', 'TransportService', '$translate', 'ModalService', function ($timeout, oAuth, $rootScope, AuthTokenService, $q, UserInfoService, TransportService, $translate, ModalService) {
        SetVersionDocumentTitle({
            $translate: $translate,
            // "portal.app.versionName.title[.${VERSION}]" l10n ID (with a version, if available for the app) will be used
            translationIdBase: 'portal.app.versionName.title'
        });
        var $ctrl = Object.create(BaseCtrl);
        var authenticationService = AuthenticationService(oAuth);
        $ctrl.loginError = ''; // errors

        var setCtrlParam = AuthComponentUtils.setCtrlParam($ctrl, $rootScope);
        $rootScope.appDn = false;
        $rootScope.invalidUser = false;

        function clearUrlToken() {
            var checkIfTokenExists = window.location.href.indexOf('?');
            if (checkIfTokenExists > -1) {
                //get full URL
                var currURL = window.location.href; //get current address
                var firstPartURL = window.location.href.split("?")[0]; //"http://www.newurl.com";
                //Get the URL between what's after '?' and before '#'
                //1- get URL after'?'
                var afterDomain = currURL.substring(currURL.lastIndexOf('?'));
                //2- get the part after '#'
                var afterQueryString = afterDomain.split("#")[1];
                var myNewURL = firstPartURL + "#" + afterQueryString;
                window.location.href = myNewURL;
            }
        }

        /**
             * Fix for Defect 0455
             * The checkPcAvailability may return a 5xx error...and the getCurrentUser may return a 404 Error.
             * Because these two services determine whether the Portal should be available to the user or not.
             * Any one that throws this error will show Portal Down message on the ui.
             */

        $q.when(AuthTokenService.accessTokenDecoded) // once user is logged in
        .then(function () {
            TransportService.send('pc', 'gateway/policy', 'checkPcAvailability') // check policycenter is up and running
            .then(function (data) {
                console.log('PC is accessible');
                //reset values back to false
                $rootScope.appDn = false;
                TransportService.send('pc', 'gateway/user', 'getCurrentUser', []) // get the user data
                .then(function (user) {
                    // process the user data and load the Portal app
                    updateUserInfo(UserInfoService, user.userType, user.publicID);
                    destroyAuthApp($rootScope);
                    restoreInitialHash();
                    triggerPortalLoad(loadPortal);
                    $rootScope.invalidUser = false;
                }).catch(function (err) {
                    console.error("Printing actual error==>" + err);
                    console.error('Couldn\'t get the user data: ', err);
                    // DEF1854-Performance-Portal Authorization has sporadic login failures
                    // clear the tokens if there are any
                    ModalService.showError('', 'portal.Invalid.LogIn', '', 'Okay', '', '').result.then(function () {
                        clearUrlToken();
                        authenticationService.logout();
                    });
                    console.log("Tokens cleared...");
                    $rootScope.invalidUser = true;
                });
            }).catch(function (err) {
                // first check if there is an invalid user login issue.
                if (err.baseError !== undefined) {
                    if (err.baseError.error.code === -32501) {
                        $rootScope.invalidUser = true;
                        setCtrlParam('loginError', 'invalidAttempt');
                    }
                } else {
                    console.error('Couldn\'t connect pc: ', err);
                    $rootScope.appDn = true;

                    ModalService.showError('', 'PortalDown.Message');
                }
                if ($rootScope.appDn) {
                    $timeout(function () {
                        // DEF1854-Performance-Portal Authorization has sporadic login failures
                        // clear the tokens if there are any
                        clearUrlToken();
                        authenticationService.logout();
                    }, 3000);
                } else {
                    ModalService.showError('', 'portal.Invalid.LogIn', '', 'Okay', '', '').result.then(function () {
                        clearUrlToken();
                        authenticationService.logout();
                    });
                }
            });
        });

        console.log("Rootscope value for AppDn is " + $rootScope.appDn);
    }]);

    angular.bootstrap($initialUiView, [initialAppName]); // initiate the auth app
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/auth-initial.js
// module id = 1605
// module chunks = 0